import { render } from "./Instrection.vue?vue&type=template&id=60947fa1"
import script from "./Instrection.vue?vue&type=script&lang=js"
export * from "./Instrection.vue?vue&type=script&lang=js"

import "./Instrection.vue?vue&type=style&index=0&id=60947fa1&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__